var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCustomIcon)?_c('img',_vm._g({style:(_vm.style),attrs:{"src":_vm.customIconUrlMapDict[_vm.value]}},_vm.$listeners)):(_vm.isHeroIcon)?_c(_vm.heroIconComponentMapDict[_vm.value],_vm._g({tag:"component",attrs:{"size":_vm.heroIconSize}},_vm.$listeners)):_c('v-icon',_vm._g({style:(_vm.style)},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }